import type {CorePlugin, SingleComponentPlugin} from '../../types'
import {createPluginFromSingleComponentPlugin} from '../../pluginsFactory'
import {pack} from './pack'

export const undefinedSingleComponentPlugin = {
    name: 'UndefinedPlugin',
    pack
} satisfies SingleComponentPlugin

export const undefinedPlugin: CorePlugin = createPluginFromSingleComponentPlugin(undefinedSingleComponentPlugin)
